// @flow
import { combineReducers } from 'redux';
import recommended from 'modules/marketplace/recommended/duck';
import search from 'modules/marketplace/search/duck';

export default combineReducers({
  recommended,
  search,
});
